import { render, staticRenderFns } from "./teaBookList.vue?vue&type=template&id=1a30007a"
import script from "./teaBookList.vue?vue&type=script&lang=js"
export * from "./teaBookList.vue?vue&type=script&lang=js"
import style0 from "./teaBookList.vue?vue&type=style&index=0&id=1a30007a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports